import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import EmployeeUploadApiRequest from "../request/EmployeeUploadApiRequest";
import EmployeeUploadApiResponse from "../model/EmployeeUploadApiResponse";
import { queryClient } from "../../../../App";
import EmployeeDataImportListRequest from "../request/EmployeeDataImportListRequest";

const EmployeeUploadApiService = async (
  request: EmployeeUploadApiRequest
): Promise<EmployeeUploadApiResponse> => {
  const uri = `/employeeimportfiles/`;

  const formData = new FormData();

  Object.keys(request).forEach((it: string) =>
    formData.append(it, request[it as keyof EmployeeUploadApiRequest])
  );

  const { data } = await axios.post(uri, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useEmployeeUploadApiService = (request: EmployeeDataImportListRequest) =>
  useMutation<EmployeeUploadApiResponse, AxiosError, EmployeeUploadApiRequest>(
    "EmployeeUploadApiService",
    EmployeeUploadApiService, {
      onSuccess: () => {
        queryClient.invalidateQueries(["EmployeeDataImportListApiService",...Object.values(request)])
      }
    }
  );

export default useEmployeeUploadApiService;
